const scrollTop = () => {
    if (document.querySelector('.kruse-scroll-up')) {
        document.addEventListener('click', ev => {
            if (!ev.target.closest('.kruse-scroll-up')) return;
            ev.preventDefault();
            // This prevents the page from scrolling down to where it was previously.
            if ('scrollRestoration' in history) {
                history.scrollRestoration = 'manual';
            }
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
        })
    }
}
export default scrollTop;